<cmps-wait-status *ngIf="hasPendingData"></cmps-wait-status>
<div *ngIf="!hasPendingData && data == null">
    {{ i18n._711_NO_DATA_AVAILABLE | translate }}
</div>
<div
    class="table-responsive"
    *ngIf="!hasPendingData && data != null"
>
    <table class="table table-striped table-sm table-bordered-no-cells">
        <thead class="thead-light">
            <tr>
                <th></th>
                <th>{{ i18n._727_TEAM_MEMBERS | translate }}</th>
                <th colspan="4">{{ i18n._134_PERFORMANCE | translate }}</th>
                <th colspan="5">{{ i18n._728_COMPLETION | translate }}</th>
            </tr>
            <tr>
                <th></th>
                <th>{{ i18n._729_TEAM_MEMBER | translate }}</th>
                <th>{{ i18n._730_CAO | translate }}</th>
                <th>{{ i18n._731___OPPORTUNITY_ALIGNMENT | translate }}</th>
                <th>{{ i18n._732_CPC | translate }}</th>
                <th>{{ i18n._733_CURRENT_OPPS | translate }}</th>
                <th>{{ i18n._734__1ST_DIAG | translate }}</th>
                <th>{{ i18n._735_GOAL_STARTED | translate }}</th>
                <th>{{ i18n._736__1ST_FOLLOW_UP | translate }}</th>
                <th>{{ i18n._737__2ND_FOLLOW_UP | translate }}</th>
                <th>{{ i18n._738_COMPLETION__MET_OR_UPDATE_ | translate }}</th>
            </tr>
        </thead>
        <tbody>
            <ng-template
                ngFor
                let-i
                let-ii="index"
                [ngForOf]="data.items"
            >
                <tr>
                    <td>
                        <button
                            type="button"
                            class="cmps-btn-table"
                            [attr.aria-expanded]="!table1RowIsCollapsed[ii]"
                            (click)="
                                table1RowIsCollapsed[ii] =
                                    !table1RowIsCollapsed[ii]
                            "
                        >
                            <cmps-icon
                                [svgIcon]="
                                    table1RowIsCollapsed[ii]
                                        ? 'arrow-right'
                                        : 'arrow-down'
                                "
                            ></cmps-icon>
                        </button>
                    </td>
                    <td>{{ i.username }}</td>
                    <td>{{ i.caoPercent / 100 | percent: '1.0-0' }}</td>
                    <td>{{ i.opsPercent / 100 | percent: '1.0-0' }}</td>
                    <td>{{ i.cpcPercent / 100 | percent: '1.0-0' }}</td>
                    <td class="text-center">
                        <button
                            type="button"
                            class="cmps-btn-table"
                            (click)="showDetails(i, ii)"
                        >
                            {{ i.currentOps }}
                        </button>
                    </td>
                    <td class="text-center">
                        <cmps-icon
                            class="cmps-cdk-fill-yellow-100"
                            svgIcon="star"
                            *ngIf="i.diag1Met"
                        ></cmps-icon>
                    </td>
                    <td class="text-center">
                        <cmps-icon
                            class="cmps-cdk-fill-yellow-100"
                            svgIcon="star"
                            *ngIf="i.goalStartedMet"
                        ></cmps-icon>
                    </td>
                    <td class="text-center">
                        <cmps-icon
                            class="cmps-cdk-fill-yellow-100"
                            svgIcon="star"
                            *ngIf="i.followUp1Met"
                        ></cmps-icon>
                    </td>
                    <td class="text-center">
                        <cmps-icon
                            class="cmps-cdk-fill-yellow-100"
                            svgIcon="star"
                            *ngIf="i.followUp2Met"
                        ></cmps-icon>
                    </td>
                    <td class="text-center">
                        <cmps-icon
                            class="cmps-cdk-fill-yellow-100"
                            svgIcon="star"
                            *ngIf="i.completionActionMet"
                        ></cmps-icon>
                    </td>
                </tr>
                <tr *ngIf="!table1RowIsCollapsed[ii]">
                    <td></td>
                    <td colspan="10">
                        <div
                            class="h6"
                            *ngIf="!i.metrics.length"
                        >
                            {{ i18n._739_NO_COACHING_FOUND | translate }}
                        </div>
                        <table
                            class="table table-striped table-sm table-bordered-no-cells"
                            *ngIf="i.metrics.length"
                        >
                            <thead class="thead-light">
                                <tr>
                                    <th></th>
                                    <th>{{ i18n._713_METRIC | translate }}</th>
                                    <th>
                                        {{
                                            i18n._740_CURRENT_PERFORMANCE
                                                | translate
                                        }}
                                    </th>
                                    <th>
                                        {{ i18n._734__1ST_DIAG | translate }}
                                    </th>
                                    <th>
                                        {{ i18n._735_GOAL_STARTED | translate }}
                                    </th>
                                    <th>
                                        {{
                                            i18n._736__1ST_FOLLOW_UP | translate
                                        }}
                                    </th>
                                    <th>
                                        {{
                                            i18n._737__2ND_FOLLOW_UP | translate
                                        }}
                                    </th>
                                    <th>
                                        {{
                                            i18n._738_COMPLETION__MET_OR_UPDATE_
                                                | translate
                                        }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <ng-template
                                    ngFor
                                    let-j
                                    let-jj="index"
                                    [ngForOf]="i.metrics"
                                >
                                    <tr>
                                        <td>
                                            <button
                                                type="button"
                                                class="cmps-btn-table"
                                                [attr.aria-expanded]="
                                                    !table2RowIsCollapsed[ii][
                                                        jj
                                                    ]
                                                "
                                                (click)="
                                                    table2RowIsCollapsed[ii][
                                                        jj
                                                    ] =
                                                        !table2RowIsCollapsed[
                                                            ii
                                                        ][jj]
                                                "
                                            >
                                                <cmps-icon
                                                    [svgIcon]="
                                                        table2RowIsCollapsed[
                                                            ii
                                                        ][jj]
                                                            ? 'arrow-right'
                                                            : 'arrow-down'
                                                    "
                                                ></cmps-icon>
                                            </button>
                                        </td>
                                        <td>{{ j.name }}</td>
                                        <td>
                                            {{
                                                j.currentActual == null
                                                    ? '-'
                                                    : (j.currentActual
                                                      | number: '1.0-0')
                                            }}
                                        </td>
                                        <td class="text-center">
                                            <cmps-icon
                                                class="cmps-cdk-fill-green-100"
                                                svgIcon="check-circle-outline"
                                                *ngIf="j.diag1Met"
                                            ></cmps-icon>
                                        </td>
                                        <td class="text-center">
                                            <cmps-icon
                                                class="cmps-cdk-fill-green-100"
                                                svgIcon="check-circle-outline"
                                                *ngIf="j.goalStartedMet"
                                            ></cmps-icon>
                                        </td>
                                        <td class="text-center">
                                            <cmps-icon
                                                class="cmps-cdk-fill-green-100"
                                                svgIcon="check-circle-outline"
                                                *ngIf="j.followUp1Met"
                                            ></cmps-icon>
                                        </td>
                                        <td class="text-center">
                                            <cmps-icon
                                                class="cmps-cdk-fill-green-100"
                                                svgIcon="check-circle-outline"
                                                *ngIf="j.followUp2Met"
                                            ></cmps-icon>
                                        </td>
                                        <td class="text-center">
                                            <cmps-icon
                                                class="cmps-cdk-fill-green-100"
                                                svgIcon="check-circle-outline"
                                                *ngIf="j.completionActionMet"
                                            ></cmps-icon>
                                        </td>
                                    </tr>
                                    <tr *ngIf="!table2RowIsCollapsed[ii][jj]">
                                        <td></td>
                                        <td colspan="7">
                                            <table
                                                class="table table-striped table-sm table-bordered-no-cells"
                                            >
                                                <thead class="thead-light">
                                                    <tr>
                                                        <th>
                                                            {{
                                                                i18n._719_CYCLES
                                                                    | translate
                                                            }}
                                                        </th>
                                                        <th>
                                                            {{
                                                                i18n._734__1ST_DIAG
                                                                    | translate
                                                            }}
                                                        </th>
                                                        <th>
                                                            {{
                                                                i18n._735_GOAL_STARTED
                                                                    | translate
                                                            }}
                                                        </th>
                                                        <th>
                                                            {{
                                                                i18n._736__1ST_FOLLOW_UP
                                                                    | translate
                                                            }}
                                                        </th>
                                                        <th>
                                                            {{
                                                                i18n._737__2ND_FOLLOW_UP
                                                                    | translate
                                                            }}
                                                        </th>
                                                        <th>
                                                            {{
                                                                i18n._741_GOAL_MET
                                                                    | translate
                                                            }}
                                                        </th>
                                                        <th>
                                                            {{
                                                                i18n._742_GOAL_UPDATED
                                                                    | translate
                                                            }}
                                                        </th>
                                                        <th>
                                                            {{
                                                                i18n._738_COMPLETION__MET_OR_UPDATE_
                                                                    | translate
                                                            }}
                                                        </th>
                                                        <th>Details</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr
                                                        *ngFor="
                                                            let k of j.coaching
                                                        "
                                                    >
                                                        <td>
                                                            {{
                                                                k.diagnosticStartDate
                                                                    | date
                                                                        : 'MMM d'
                                                            }}
                                                            to
                                                            {{
                                                                k.followUpEndDate
                                                                    | date
                                                                        : 'MMM d'
                                                            }}
                                                        </td>
                                                        <td>
                                                            <button
                                                                type="button"
                                                                class="cmps-btn-table"
                                                                role="link"
                                                                (click)="
                                                                    goToJournal(
                                                                        k.diagObs1JournalUrl
                                                                    )
                                                                "
                                                                *ngIf="
                                                                    k.diagObs1Date
                                                                "
                                                            >
                                                                {{
                                                                    k.diagObs1Date
                                                                        | date
                                                                            : 'y-MM-dd'
                                                                }}
                                                            </button>
                                                        </td>
                                                        <td>
                                                            <button
                                                                type="button"
                                                                class="cmps-btn-table"
                                                                role="link"
                                                                (click)="
                                                                    goToJournal(
                                                                        k.primaryGoalJournalUrl
                                                                    )
                                                                "
                                                                *ngIf="
                                                                    k.primaryGoalStartDate
                                                                "
                                                            >
                                                                {{
                                                                    k.primaryGoalStartDate
                                                                        | date
                                                                            : 'y-MM-dd'
                                                                }}
                                                            </button>
                                                        </td>
                                                        <td>
                                                            <button
                                                                type="button"
                                                                class="cmps-btn-table"
                                                                role="link"
                                                                (click)="
                                                                    goToJournal(
                                                                        k.followUp1JournalUrl
                                                                    )
                                                                "
                                                                *ngIf="
                                                                    k.followUp1Date
                                                                "
                                                            >
                                                                {{
                                                                    k.followUp1Date
                                                                        | date
                                                                            : 'y-MM-dd'
                                                                }}
                                                            </button>
                                                        </td>
                                                        <td>
                                                            <button
                                                                type="button"
                                                                class="cmps-btn-table"
                                                                role="link"
                                                                (click)="
                                                                    goToJournal(
                                                                        k.followUp2JournalUrl
                                                                    )
                                                                "
                                                                *ngIf="
                                                                    k.followUp2Date
                                                                "
                                                            >
                                                                {{
                                                                    k.followUp2Date
                                                                        | date
                                                                            : 'y-MM-dd'
                                                                }}
                                                            </button>
                                                        </td>
                                                        <td class="text-center">
                                                            <cmps-icon
                                                                class="cmps-cdk-fill-green-100"
                                                                svgIcon="check-circle-outline"
                                                                *ngIf="
                                                                    k.wasGoalMet
                                                                "
                                                            ></cmps-icon>
                                                        </td>
                                                        <td class="text-center">
                                                            <cmps-icon
                                                                class="cmps-cdk-fill-green-100"
                                                                svgIcon="check-circle-outline"
                                                                *ngIf="
                                                                    k.wasFollowUpGoalCreated
                                                                "
                                                            ></cmps-icon>
                                                        </td>
                                                        <td>
                                                            <button
                                                                type="button"
                                                                class="cmps-btn-table"
                                                                role="link"
                                                                (click)="
                                                                    goToJournal(
                                                                        k.completionJournalUrl
                                                                    )
                                                                "
                                                                *ngIf="
                                                                    k.completionDate
                                                                "
                                                            >
                                                                {{
                                                                    k.completionDate
                                                                        | date
                                                                            : 'y-MM-dd'
                                                                }}
                                                            </button>
                                                        </td>
                                                        <td>
                                                            <button
                                                                type="button"
                                                                class="cmps-btn-table"
                                                                (click)="
                                                                    showMetricCyclePerformance(
                                                                        j
                                                                    )
                                                                "
                                                            >
                                                                <cmps-icon
                                                                    svgIcon="folder-outline"
                                                                ></cmps-icon>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                </ng-template>
                            </tbody>
                        </table>
                    </td>
                </tr>
            </ng-template>
        </tbody>
        <tfoot class="tfoot-light">
            <tr>
                <th></th>
                <th>{{ i18n._743_SUMMARY | translate }}</th>
                <th>{{ data.overall.caoPercent / 100 | percent: '1.0-0' }}</th>
                <th>{{ data.overall.opsPercent / 100 | percent: '1.0-0' }}</th>
                <th>{{ data.overall.cpcPercent / 100 | percent: '1.0-0' }}</th>
                <th class="text-center">{{ data.overall.currentOps }}</th>
                <th>
                    {{ data.overall.diag1Performed }}({{
                        data.overall.diag1Percent / 100 | percent: '1.0-0'
                    }})
                </th>
                <th>
                    {{ data.overall.goalStartedPerformed }}({{
                        data.overall.goalStartedPercent / 100
                            | percent: '1.0-0'
                    }})
                </th>
                <th>
                    {{ data.overall.followUp1Performed }}({{
                        data.overall.followUp1Percent / 100 | percent: '1.0-0'
                    }})
                </th>
                <th>
                    {{ data.overall.followUp2Performed }}({{
                        data.overall.followUp2Percent / 100 | percent: '1.0-0'
                    }})
                </th>
                <th>
                    {{ data.overall.completionActionPerformed }}({{
                        data.overall.completionActionPercent / 100
                            | percent: '1.0-0'
                    }})
                </th>
            </tr>
        </tfoot>
    </table>
</div>
<div
    *ngIf="!!currentDetail || !!currentMetricCyclePerformance"
    #popupEl
>
    <div
        class="card"
        *ngIf="!!currentDetail"
    >
        <div class="card-header">
            <span>{{
                i18n._744_OPPORTUNITIES_FOR__NAME_
                    | translate: { name: currentDetail.username }
            }}</span>
            <button
                type="button"
                class="close ml-3"
                [attr.aria-label]="i18n._763_CLOSE | translate"
                (click)="currentDetail = null"
            >
                <cmps-icon svgIcon="close"></cmps-icon>
            </button>
        </div>
        <div class="card-body">
            <cmps-widget-cao-details
                [managerId]="data.managerId"
                [userId]="currentDetail.userId"
            ></cmps-widget-cao-details>
        </div>
    </div>
    <div
        class="card"
        *ngIf="!!currentMetricCyclePerformance"
    >
        <div class="card-header">
            <span>{{ i18n._745_COACHING_CYCLE_PERFORMANCE | translate }}</span>
            <button
                type="button"
                class="close ml-3"
                [attr.aria-label]="i18n._763_CLOSE | translate"
                (click)="currentMetricCyclePerformance = null"
            >
                <cmps-icon svgIcon="close"></cmps-icon>
            </button>
        </div>
        <div class="card-body">
            <cmps-widget-cao-metric-cycle-performance
                [metric]="currentMetricCyclePerformance"
            ></cmps-widget-cao-metric-cycle-performance>
        </div>
    </div>
</div>
